import { render, staticRenderFns } from "./app-nav.vue?vue&type=template&id=2206233c&scoped=true"
import script from "./app-nav.vue?vue&type=script&lang=ts"
export * from "./app-nav.vue?vue&type=script&lang=ts"
import style0 from "./app-nav.vue?vue&type=style&index=0&id=2206233c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206233c",
  null
  
)

export default component.exports